// Libs
import {HashRouter} from 'react-router-dom';
import {createRoot} from 'react-dom/client';
import {UnauthenticatedContent} from './UnauthenticatedContent';
import {Spinner} from './components/spinner';
import AuthProvider, {useAuth} from './AuthProvider';
import AuthenticatedContent from './AuthenticatedContent';

const App = ({userConfig}: any) => {
  const {isAuth, user} = useAuth() || {};

  if (!userConfig) return <Spinner />;

  if (isAuth) {
    return <AuthenticatedContent user={user} userConfig={userConfig} />;
  }

  return <UnauthenticatedContent userConfig={userConfig} />;
};

export default function initApplication(userConfig: any) {
  function LoadScript() {
    return (
      <HashRouter>
        <AuthProvider>
          <App userConfig={userConfig} />
        </AuthProvider>
      </HashRouter>
    );
  }

  const container = document.getElementById('root');
  const root = createRoot(container!);
  root.render(<LoadScript />);
}
